module.exports = __webpack_public_path__ + "img/14dayguarantee.078bffd7.svg";